/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ ⚠️⚠️ IS THIS A PHONE? — asked once, at the moment a surface is chosen.     │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * `nextSurface` in `@forecastify/ui` carries item 34's ladder — *a drill-in from a list opens as a
 * modal* — and it is deliberately viewport-blind: the ladder is about where you came FROM, and a
 * component library that guessed at screen sizes would be guessing for every caller.
 *
 * Feedback round 4 item 24 adds the one exception that is not about the ladder: **a modal on
 * desktop, a drawer on a phone.** A 960px modal centred in a 390px viewport is a drawer with worse
 * margins, so on a phone the drawer is simply the better shape for the same content.
 *
 * ⚠️ **A function rather than a hook, and it is called when a surface OPENS.** A hook that
 * subscribed to the query would re-shape a surface somebody already has open, mid-read, on a
 * rotation — which is a worse answer than the one they started with. What a resize should change
 * is the NEXT thing they open.
 *
 * ⚠️ **`matchMedia` is absent in jsdom unless a test stubs it, so its absence reads as *not
 * narrow*** — the desktop answer, which is what every test that does not care is asking for.
 * `auth-backdrop.tsx` makes the same call for `prefers-reduced-motion`.
 */
export function isNarrowViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  /* ⚠️ The same 640px `sm` breakpoint the screens lay out against — one number, not two. */
  return window.matchMedia('(max-width: 639px)').matches;
}
